import {
  Users,
  ShieldCheck,
  Award,
  Sparkles,
  Clock4,
  Handshake,
  CheckCircle2,
} from "lucide-react";
import Reveal from "@/components/Reveal";

const REASONS = [
  {
    icon: Users,
    title: "Customer First Approach",
    desc: "Your goals are our priority.",
  },
  {
    icon: ShieldCheck,
    title: "Transparent & Ethical Services",
    desc: "Honesty and transparency in everything we do.",
  },
  {
    icon: Award,
    title: "Expertise You Can Trust",
    desc: "Experienced professionals committed to your growth.",
  },
  {
    icon: Sparkles,
    title: "Tailored Financial Solutions",
    desc: "Solutions designed specifically for your needs.",
  },
  {
    icon: Clock4,
    title: "Quick Turnaround Time",
    desc: "Fast, efficient and hassle-free service.",
  },
  {
    icon: Handshake,
    title: "Long-Term Relationship",
    desc: "We grow when you grow.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us"
      className="relative bg-[#04102B] text-white py-24 md:py-32 overflow-hidden noise-overlay"
    >
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full border border-[#D4AF37]/8" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center">
            <span className="gold-divider text-[11px] tracking-[0.32em] uppercase">
              · Why choose us ·
            </span>
            <h2
              data-testid="why-heading"
              className="font-display text-[40px] md:text-[60px] mt-5 leading-[1.05] tracking-tight"
            >
              Your success is our <em className="not-italic text-[#D4AF37]">commitment</em>.
            </h2>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REASONS.map(({ icon: Icon, title, desc }, i) => (
            <Reveal key={title} delay={i * 70}>
              <div
                data-testid={`why-card-${i + 1}`}
                className="group relative h-full rounded-2xl p-7 border border-[#D4AF37]/22 bg-white/[0.03] hover:bg-white/[0.06] hover:border-[#D4AF37]/65 hover:-translate-y-1 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-[#0F6B3D]/15 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="flex items-start gap-3">
                  <span className="w-8 h-8 rounded-full grid place-items-center bg-[#0F6B3D] text-[#F0D788] shrink-0">
                    <CheckCircle2 size={16} strokeWidth={2} />
                  </span>
                  <div className="flex-1">
                    <h3 className="font-display text-xl md:text-[22px] tracking-wide uppercase text-white leading-snug">
                      {title}
                    </h3>
                    <p className="mt-2 text-white/65 text-sm leading-relaxed">{desc}</p>
                  </div>
                </div>
                <div className="mt-5 ml-11 inline-flex items-center gap-2 text-[#D4AF37]">
                  <Icon size={18} strokeWidth={1.75} />
                  <span className="font-display text-white/15 text-2xl">0{i + 1}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
